import { Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import useEditorParams from '../../../newEditor/hook/params';
import useEditor from '../../../newEditor/hook/editor';
import EditorContainer from '../../../newEditor/editorContainer';
import { CatCommandPanel } from '../../../newEditor/commandPanels';
import { DocumentBody, Footer } from '../../../../components/Containers/docs';
import HidableContainer from '../../../documents/common/hidableContainer';
import { EditorControls, editorHooks } from '../../../basicEditor/editorControls';
import meta from '../../../../meta';

const { backendURL } = meta.cat.contragent;

function Editor({
  onSave, onClose, id,
}) {
  const editorParams = useEditorParams();
  const {
    data, actions, fields, fieldErrors, nonFieldErrors, options, isNew, changed, permissions,
    loading, systemErrors, headerReadOnlyFields, printForms, headerProps,
  } = useEditor({
    backendURL,
    id,
    onCloseCallBack: onClose,
    onSaveCallBack: onSave,
    ...editorParams,
  });

  const fullnameProps = editorHooks.useStringInputProps('fullname', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const nameProps = editorHooks.useStringInputProps('name', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const edrpouProps = editorHooks.useStringInputProps('edrpou', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const parent = editorHooks.useItemInputProps('parent', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const deletedProps = editorHooks.useCheckboxInputProps('deleted', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const email = editorHooks.useStringInputProps('email', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const addresss = editorHooks.useStringInputProps('address', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);
  const phoneNumber = editorHooks.useStringInputProps('phone_number', data, fields, fieldErrors, actions.onChange, false, headerReadOnlyFields);

  return (
    <EditorContainer
      isNew={isNew}
      name={options.name}
      repr={data.repr}
      isLoading={loading}
      err={systemErrors}
      nonFieldErrors={nonFieldErrors}
      onClearNonFieldErrors={actions.onClearNonFieldErrors}
      onClearErrors={actions.onClearErrs}
      onClose={actions.onClose}
      changed={changed}
      fields={fields}
      CommandPanel={(
        <CatCommandPanel
          backendURL={backendURL}
          permissions={permissions}
          actions={actions}
          changed={changed}
          executed={data.executed}
          printForms={printForms}
          id={id}
          repr={data.repr}
        />
      )}
    >
      <DocumentBody>
        <HidableContainer>
          <Container fluid style={{ padding: '0' }}>
            <Row>
              <Col>
                <EditorControls.StringInput {...nameProps} />
              </Col>
              <Col>
                <EditorControls.StringInput {...fullnameProps} />
              </Col>
            </Row>
            {!data.is_group && (
              <Row>
                <Col>
                  <EditorControls.StringInput {...edrpouProps} />
                </Col>
                <Col>
                  <EditorControls.StringInput {...email} />
                </Col>
                <Col>
                  <EditorControls.StringInput {...phoneNumber} />
                </Col>
                <Col xl={6}>
                  <EditorControls.StringInput {...addresss} />
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <EditorControls.ItemPicker
                  {...parent}
                  noNew
                  noFolder
                  filter={{ is_group: true }}
                />
              </Col>
              <Col className="mt-2">
                <EditorControls.CheckboxInput {...deletedProps} />
              </Col>
            </Row>
          </Container>
        </HidableContainer>
      </DocumentBody>
      <Footer
        created={data.created_at}
        updated={data.updated_at}
        readOnly={!permissions.canChange}
        inspection={data.inspection}
        authority={data.authority}
        author={data.author}
        onChange={actions.onChange}
        id={id}
        headerProps={headerProps}
      />
    </EditorContainer>
  );
}

Editor.propTypes = {
  id: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

Editor.defaultProps = {
  onClose: null,
  onSave: null,
};

export default Editor;
